export function initialize() {

  var animationDelay = 4000

  // Handle the words:
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  function animateHeadline($headlines) {
    $headlines.each(function(){
      var headline = $(this)
      setTimeout(function(){ hideWord( headline.find('.is-visible') ) }, animationDelay)
    })
  }

  function hideWord($word) {
    var nextWord = takeNextWord($word)
    switchWord($word, nextWord)
    setTimeout(function(){ hideWord(nextWord) }, animationDelay)
  }

  function takeNextWord($word) {
    return (!$word.is(':last-child')) ? $word.next() : $word.parent().children().eq(0)
  }

  function switchWord($oldWord, $newWord) {
    $oldWord.removeClass('is-visible').addClass('is-hidden')
    $newWord.removeClass('is-hidden').addClass('is-visible')
  }

  animateHeadline($('.hero-x-platform__main-title'))

  // Handle the background images:
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  function animateImage($images) {
    $images.each(function(){
      var image = $(this)
      setTimeout(function(){ hideImage( image.find('.is-visible') ) }, animationDelay)
    })
  }

  function hideImage($image) {
    var nextImage = takeNextImage($image)
    switchImage($image, nextImage)
    setTimeout(function(){ hideImage(nextImage) }, animationDelay)
  }

  function takeNextImage($image) {
    return (!$image.is(':last-child')) ? $image.next() : $image.parent().children().eq(0)
  }

  function switchImage($oldImage, $newImage) {
    $oldImage.removeClass('is-visible').addClass('is-hidden')
    $newImage.removeClass('is-hidden').addClass('is-visible')
  }

  animateImage($('.hero-x-platform__main-images'))

}
